import * as Yup from 'yup'; 
import { onlyChars } from '../../components/form/Helpers/Parsers'
import { FieldTypes, IFields, InputModes } from '../../models/form/IFieldsDefinition'
import { isPeselValid } from '../../components/form/Validations/PeselValidation'
import { isNameValid } from '../../components/form/Validations/NamesValidation'
import { isEmailValid, isEmailEqualCustomValidation } from '../../components/form/Validations/EmailValidation'
import { isPhoneNumberValid } from '../../components/form/Validations/PhoneNumberValidation'
import { FormValidationObject } from '../../models/form/IFormDefinition'


export enum BasicInfoFieldsNames {
   FirstName = "FirstName",
   Surname = "Surname",
   Pesel = "Pesel",
   PhoneNumber = "PhoneNumber",
   Email = "Email",
   ConfirmEmail = "ConfirmEmail",
}

const fetchFirstNameSuggestions = async (query: string): Promise<string[]> => {
   const { default: esService } = await import('../../service/es-service')
   return esService.getFirstNames(query)
}

const fetchSurnameSuggestions = async (query: string): Promise<string[]> => {
   const { default: esService } = await import('../../service/es-service')
   return esService.getLastNames(query)
}

export const basicInfoFields: IFields = {
   [BasicInfoFieldsNames.FirstName]: {
      order: 0,
      name: BasicInfoFieldsNames.FirstName,
      type: FieldTypes.string,
      label: "Imię",
      maxLength: 50,
      editable: true,
      parser: onlyChars,
      suggestionsProvider: fetchFirstNameSuggestions,
      suggestionsMinLength: 2,
   },
   [BasicInfoFieldsNames.Surname]: {
      order: 5,
      name: BasicInfoFieldsNames.Surname,
      type:  FieldTypes.string,
      label: "Nazwisko",
      maxLength: 50,
      editable: true,
      parser: onlyChars,
      suggestionsProvider: fetchSurnameSuggestions,
      suggestionsMinLength: 2,
   },
   [BasicInfoFieldsNames.Pesel]: {
      order: 10,
      name: BasicInfoFieldsNames.Pesel,
      type:  FieldTypes.string,
      label: "Pesel",
      editable: true,
      mask: "99999999999",
      inputMode: InputModes.numeric,
   },

   [BasicInfoFieldsNames.PhoneNumber]: {
      order: 15,
      name: BasicInfoFieldsNames.PhoneNumber,
      type:  FieldTypes.phone,
      label: "Numer telefonu",
      mask: "+48 999-999-999",
      editable: true,
      inputMode: InputModes.numeric,
   },
   [BasicInfoFieldsNames.Email]: {
      order: 20,
      name: BasicInfoFieldsNames.Email,
      type:  FieldTypes.email,
      label: "Adres e-mail",
      maxLength: 50,
      editable: true,
      inputMode: InputModes.email,
   },
   [BasicInfoFieldsNames.ConfirmEmail]: {
      order: 25,
      name: BasicInfoFieldsNames.ConfirmEmail,
      type:  FieldTypes.email,
      label: "Potwierdź adres e-mail",
      maxLength: 50,
      editable: true,
      isPasteDisabled: true,
      inputMode: InputModes.email,
   },
}

export const basicInfoFormValidations: FormValidationObject<typeof BasicInfoFieldsNames> = {
   [BasicInfoFieldsNames.FirstName]: Yup.string().trim().required("Niepoprawna wartość").test(isNameValid) as Yup.StringSchema<string>,
   [BasicInfoFieldsNames.Surname]: Yup.string().trim().required("Nieprawidłowa wartość").min(3, "Nieprawidłowa wartość") as Yup.StringSchema<string>,
   [BasicInfoFieldsNames.Pesel]: Yup.string().required('Nieprawidłowa wartość').test(isPeselValid) as Yup.StringSchema<string>,
   [BasicInfoFieldsNames.PhoneNumber]: Yup.string().test(isPhoneNumberValid) as Yup.StringSchema<string>,
   [BasicInfoFieldsNames.Email]: Yup.string().test(isEmailValid) as Yup.StringSchema<string>,
   [BasicInfoFieldsNames.ConfirmEmail]: isEmailEqualCustomValidation,
}